// extracted by mini-css-extract-plugin
export default {"container":"search_results_container__21TXf","no_products":"search_results_no_products__T2BmX"};